import React, {useEffect, useState} from 'react';
import Api from "../../utils/api";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/lab/Autocomplete";




const MarketerList = ({onChange , label}) => {
    const [marketerList, setMarketerList] = useState([])

    useEffect(() => {

        handleMarketerList()

    } ,[])

    const handleMarketerList = (e) => {
        new Api().get('/marketers/autocomplete', {
            "term": e?.target?.value ?? ""
        } ,false).then((response) => {
            if (typeof response !== "undefined") {
                setMarketerList(response);
            }

        })
    }


    return (
        <>
            {
                <Grid item={true} xs={12} sm={12}>
                    <Autocomplete
                        autoComplete={'off'}
                        onChange={(( event, value) => onChange(value))}
                        options={marketerList}
                        getOptionLabel={(option) => option.name}
                        renderInput={(params) =>
                            <TextField
                                autoComplete={"off"}
                                {...params}
                                fullWidth
                                name='parent_id'
                                margin={"dense"}
                                label={label}
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onChange={((event, value) => handleMarketerList(event, value))}
                            />
                        }
                    />
                </Grid>
            }

        </>
    );
};

export default MarketerList;